import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import {
  ArmazenamentoClientesService,
  ArquivoCliente,
  formataBytes,
  nomePasta,
  ResumoArquivos,
  UsoCliente,
} from 'src/app/services/armazenamento-clientes.service';

interface LinhaCliente extends UsoCliente {
  percentual: number;
  situacao: 'ok' | 'perto' | 'acima';
}

const GB = 1000000000;

@Component({
  selector: 'habil-armazenamento-clientes',
  templateUrl: './armazenamento-clientes.component.html',
  styleUrls: ['./armazenamento-clientes.component.scss'],
})
export class ArmazenamentoClientesComponent implements OnInit {
  formataBytes = formataBytes;
  nomePasta = nomePasta;

  carregando = false;
  erro = '';
  todos: LinhaCliente[] = [];
  lista: LinhaCliente[] = [];

  busca = '';
  situacao = '';
  situacoes = [
    { label: 'Todos', value: '' },
    { label: 'Acima do limite', value: 'acima' },
    { label: 'Perto do limite (80%+)', value: 'perto' },
  ];

  totalGeral = 0;
  arquivosGeral = 0;
  qtdeAcima = 0;
  qtdePerto = 0;

  cliente: LinhaCliente = null;
  mostraCliente = false;
  resumo: ResumoArquivos = null;
  pastaOpcoes: { label: string; value: string }[] = [];
  carregandoResumo = false;

  limiteGb: number = null;
  salvandoLimite = false;
  mensagemLimite = '';
  erroLimite = '';

  arquivos: ArquivoCliente[] = [];
  totalArquivos = 0;
  carregandoArquivos = false;
  erroArquivos = '';
  filtroArquivos = { pasta: '', busca: '', ordem: 'recentes' };
  ordens = [
    { label: 'Mais recentes', value: 'recentes' },
    { label: 'Mais antigos', value: 'antigos' },
    { label: 'Maiores', value: 'maiores' },
    { label: 'Nome', value: 'nome' },
  ];
  inicioArquivos = 0;
  qtdePorPagina = 50;
  abrindo: number = null;

  constructor(private service: ArmazenamentoClientesService, breadcrumbService: BreadcrumbService) {
    breadcrumbService.setItems([{ label: 'Administração' }, { label: 'Armazenamento dos clientes' }]);
  }

  ngOnInit(): void {
    this.carregar();
  }

  carregar() {
    this.carregando = true;
    this.erro = '';
    this.service.clientes().subscribe({
      next: (r) => {
        this.carregando = false;
        this.todos = (r || []).map((c) => this.linha(c));
        this.totalGeral = this.todos.reduce((s, c) => s + c.total, 0);
        this.arquivosGeral = this.todos.reduce((s, c) => s + c.quantidade, 0);
        this.qtdeAcima = this.todos.filter((c) => c.situacao === 'acima').length;
        this.qtdePerto = this.todos.filter((c) => c.situacao === 'perto').length;
        this.filtrar();
      },
      error: (e) => {
        this.carregando = false;
        this.erro = e?.error?.erro || 'Não foi possível buscar o uso dos clientes no Hábil Upload.';
      },
    });
  }

  filtrar() {
    const texto = (this.busca || '').trim().toLowerCase();
    const digitos = texto.replace(/\D/g, '');
    this.lista = this.todos.filter((c) => {
      if (this.situacao && c.situacao !== this.situacao) {
        return false;
      }
      if (!texto) {
        return true;
      }
      return (c.nome || '').toLowerCase().includes(texto) || (digitos.length >= 3 && c.cnpj.includes(digitos));
    });
  }

  filtraSituacao(situacao: string) {
    this.situacao = this.situacao === situacao ? '' : situacao;
    this.filtrar();
  }

  abrir(c: LinhaCliente) {
    this.cliente = c;
    this.mostraCliente = true;
    this.resumo = null;
    this.pastaOpcoes = [];
    this.limiteGb = Math.round((c.limite / GB) * 100) / 100;
    this.mensagemLimite = '';
    this.erroLimite = '';
    this.filtroArquivos = { pasta: '', busca: '', ordem: 'recentes' };
    this.arquivos = [];
    this.totalArquivos = 0;
    this.inicioArquivos = 0;
    this.carregandoResumo = true;
    this.service.resumo(c.cnpj).subscribe({
      next: (r) => {
        this.carregandoResumo = false;
        this.resumo = r;
        this.pastaOpcoes = [{ label: 'Todas', value: '' }].concat((r?.pastas || []).map((p) => ({ label: nomePasta(p.pasta), value: p.pasta })));
      },
      error: () => (this.carregandoResumo = false),
    });
  }

  filtraPasta(pasta: string) {
    this.filtroArquivos.pasta = this.filtroArquivos.pasta === pasta ? '' : pasta;
    this.buscarArquivos(0);
  }

  buscarArquivos(inicio = 0) {
    if (!this.cliente) {
      return;
    }
    this.inicioArquivos = inicio;
    this.carregandoArquivos = true;
    this.erroArquivos = '';
    this.service
      .arquivos(this.cliente.cnpj, { ...this.filtroArquivos, inicio, quantidade: this.qtdePorPagina })
      .subscribe({
        next: (r) => {
          this.carregandoArquivos = false;
          this.arquivos = r?.registros || [];
          this.totalArquivos = r?.total || 0;
        },
        error: (e) => {
          this.carregandoArquivos = false;
          this.erroArquivos = e?.error?.erro || 'Não foi possível listar os arquivos.';
        },
      });
  }

  paginarArquivos(ev: any) {
    if (!this.cliente) {
      return;
    }
    this.qtdePorPagina = ev.rows;
    this.buscarArquivos(ev.first);
  }

  abrirArquivo(a: ArquivoCliente) {
    this.abrindo = a.id;
    const janela = window.open('', '_blank');
    this.service.urlArquivo(this.cliente.cnpj, a.s3Filename).subscribe({
      next: (r) => {
        this.abrindo = null;
        if (r?.url && janela) {
          janela.opener = null;
          janela.location.href = r.url;
        } else {
          janela?.close();
          this.erroArquivos = r?.url ? 'O navegador bloqueou a nova aba. Libere pop-ups para a Central.' : 'Este arquivo não tem endereço para abrir.';
        }
      },
      error: (e) => {
        this.abrindo = null;
        janela?.close();
        this.erroArquivos = e?.error?.erro || 'Não foi possível abrir o arquivo.';
      },
    });
  }

  salvarLimite() {
    this.mensagemLimite = '';
    this.erroLimite = '';
    const bytes = Math.round((Number(this.limiteGb) || 0) * GB);
    if (bytes <= 0) {
      this.erroLimite = 'Informe um limite maior que zero.';
      return;
    }
    this.salvandoLimite = true;
    this.service.salvarLimite(this.cliente.cnpj, bytes).subscribe({
      next: (r) => {
        this.salvandoLimite = false;
        const atualizado = this.linha({ ...this.cliente, limite: r.limite });
        Object.assign(this.cliente, atualizado);
        this.qtdeAcima = this.todos.filter((c) => c.situacao === 'acima').length;
        this.qtdePerto = this.todos.filter((c) => c.situacao === 'perto').length;
        this.filtrar();
        this.mensagemLimite = 'Limite salvo.';
      },
      error: (e) => {
        this.salvandoLimite = false;
        this.erroLimite = e?.error?.erro || 'Não foi possível salvar o limite.';
      },
    });
  }

  larguraBarra(percentual: number): number {
    return Math.min(Math.max(percentual, 0), 100);
  }

  private linha(c: UsoCliente): LinhaCliente {
    const limite = Number(c.limite) || 0;
    const total = Number(c.total) || 0;
    const percentual = limite > 0 ? (total / limite) * 100 : 0;
    return {
      ...c,
      limite,
      total,
      quantidade: Number(c.quantidade) || 0,
      percentual,
      situacao: percentual > 100 ? 'acima' : percentual >= 80 ? 'perto' : 'ok',
    };
  }
}
